<template>
  <div class="">
    
    <!-- 查询表单 -->
    <div>
      <el-form ref="storeProgramForm" :model="storeProgramForm" label-width="80px">
        <el-row :gutter="20">
          <el-col :xs="24" :sm="24" :md="12" :lg="12" :xl="6">
            <el-form-item label="创建时间">
              <el-date-picker clearable
                v-model="storeProgramForm.createTime"
                type="daterange"
                align="right"
                unlink-panels
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                :picker-options="pickerOptions">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="商户名称">
             <el-input clearable v-model="storeProgramForm.merchantLike"  placeholder="请输入商户名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="门店">
             <el-input clearable v-model="storeProgramForm.storeLike"  placeholder="请输入门店名称或ID"></el-input>
            </el-form-item>
          </el-col>
          <el-col :xs="24" :sm="24" :md="12" :lg="8" :xl="6">
            <el-form-item label="联系人">
             <el-input clearable v-model="storeProgramForm.storeContactLike"  placeholder="请输联系人名称或电话"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="3">
            <el-button type="primary" @click="getStoreList">查询</el-button>
            <el-button type="primary" @click="addStore">添加</el-button>
          </el-col>
           <el-col :span="2">
              <el-upload
                  style="display:inline"
                  action="aa"
                  :show-file-list="false"
                  :before-upload="importStore">
                  <el-button  type="primary" v-loading="fullscreenLoading">批量导入</el-button>
                </el-upload>
           </el-col>
            <el-col :span="2" style="margin-top:10px">
                   <a  type="primary" style="margin: 0 10px" @click="getStoreTemplate">导入模板下载</a>
           </el-col>
        </el-row>
      </el-form>
    </div>
    <div style="margin-top: 20px;">
            <!-- 表格 -->
       <el-table
        :data="tableData"
        border
        style="width: 100%">
          <el-table-column
            prop="code"
            label="门店ID">
          </el-table-column>
          <el-table-column
            prop="name"
            label="门店名称">
          </el-table-column>
          <el-table-column
            prop="contactPerson"
            label="门店联系人">
          </el-table-column>
          <el-table-column
            prop="contactNumber"
            label="联系人电话">
          </el-table-column>
          <el-table-column
            prop="merchantName"
            label="所属商户">
          </el-table-column>
          <el-table-column
            prop="areaName"
            label="所属区域">
          </el-table-column>
           <el-table-column
             prop="address"
             label="地址">
           </el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间">
          </el-table-column>
          <el-table-column
            prop="status"
            label="门店状态">
              <template slot-scope="scope">
                <span v-if="scope.row.status === 1">开启</span>
                <span v-if="scope.row.status === 0">关闭</span>
              </template>
          </el-table-column>
          <el-table-column
            label="操作">
              <template slot-scope="scope">
                <el-button @click="editorStore(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="openStore(scope.row.id)" type="text" size="small" v-if="scope.row.status === 0">开启</el-button>
                <el-button @click="closeStore(scope.row.id)" type="text" size="small" style="color: red;" v-else>关闭</el-button>
                <el-button @click="deleteStore(scope.row.id)" type="text" size="small" style="color: gray;">删除</el-button>
              </template>
          </el-table-column>
      </el-table>
      

      <!-- 分页 -->
      <el-pagination style="margin-top: 20px;"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 40, 100]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="tableTotal">
      </el-pagination>
    </div>

    <!-- 修改或新建城市经理对话框 -->
    <el-dialog :title="dlgType === 'change' ? '编辑门店' : '新建门店'" :visible.sync="isDlg" width="700px">
      <div style="margin: 20px;">
        <div>
           <!-- {
        code: null,
        storeId: null,
        contactNumber: null,
        contactPerson: null,
        name: null,
        linkageId: null,
        merchantId: null,
      } -->
          <el-form ref="editStoreOneForm" :model="editStoreOneForm" :rules="editorFormRules" label-width="140px">
            <el-form-item label="门店ID" v-if="dlgType === 'change'">
              <el-input clearable v-model="editStoreOneForm.code" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="门店名称" prop="name">
              <el-input clearable v-model="editStoreOneForm.name"></el-input>
            </el-form-item>
            <el-form-item label="门店联系人" prop="contactPerson">
              <el-input clearable v-model="editStoreOneForm.contactPerson"></el-input>
            </el-form-item>
            <el-form-item label="联系人电话" prop="contactNumber">
              <el-input clearable v-model="editStoreOneForm.contactNumber"></el-input>
            </el-form-item>
              <el-form-item label="地址" prop="address">
                  <el-input clearable v-model="editStoreOneForm.address"></el-input>
              </el-form-item>
            <el-form-item label="所属商户" prop="merchantId">
              <el-select clearable
                v-model="editStoreOneForm.merchantId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :remote-method.sync="getMerchantList"
                :loading="loading">
                <el-option
                  v-for="item in merchatOptions"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="所属区域" prop="linkageId">
              <el-select clearable
                v-model="editStoreOneForm.linkageId"
                filterable
                remote
                placeholder="请输入关键词"
                reserve-keyword
                :remote-method.sync="getCityThreeList"
                :loading="loading">
                <el-option
                  v-for="item in cityThreeOptions"
                  :key="item.id"
                  :label="item.linkageName"
                  :value="item.id">
                </el-option>
              </el-select>
            </el-form-item>
              <el-form-item label="收款二维码" prop="payQrcode">
                  <el-upload
                             class="avatar-uploader"
                             action="aa"
                             :show-file-list="false"
                             :on-success="handleSuccess"
                             :before-upload="handleBeforeUpload"
                             :on-change="uploadImg">
                      <img v-if="editStoreOneForm.payQrcode" :src="editStoreOneForm.payQrcode" class="avatar">
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                  </el-upload>
              </el-form-item>
               <el-form-item label="门店总未回额度" prop="storeQuota" v-if="userInfo.data.roleId==1">
                <el-input clearable v-model="editStoreOneForm.storeQuota" placeholder="请输入正整数"></el-input>
              </el-form-item>
              <el-form-item label="单店员未回额度" prop="singleQuota" v-if="userInfo.data.roleId==1">
                <el-input clearable v-model="editStoreOneForm.singleQuota" placeholder="请输入正整数"></el-input>
              </el-form-item>
          </el-form>
        </div>
        <div style="text-align: center;">
          <el-button type="primary" style="margin: 30px 20px;" @click="submitEditor">确定</el-button>
          <el-button style="margin: 10px 20px;" @click="closeEditorStoreDlg">暂不</el-button>
        </div>
      </div>
    </el-dialog>

  </div>
</template>

<script>
export default {
  components:{},
  props:{},
  data(){
    return {
      // 查询数据
      storeProgramForm: {
        createTime: [],
        merchantLike: '',
        storeContactLike: '',
        storeLike: '',
      },

      // 日期选择插件配置
      pickerOptions: {
        shortcuts: [{
          text: '最近一周',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近一个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
          }
        }, {
          text: '最近三个月',
          onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
          }
        }]
      },

      // 表格数据
      tableTotal: 0,
      tableData: [],
      pageSize: 10,
      currentPage: 1,

      userInfo:{data:{}},

      // 新建编辑对话框数据

      isDlg: false,
      editStoreOneForm: {
        id: null,
        code: null,
        storeId: null,
        contactNumber: null,
        contactPerson: null,
        name: null,
        linkageId: null,
        merchantId: null,
        status: 0,
        storeQuota:null,
        singleQuota:null
      },

      editorFormRules: {
        name: [
          { required: true, message: '请输入门店名称', trigger: 'change' },
        ],
        contactPerson: [
          { required: true, message: '请输入门店联系人', trigger: 'change' },
        ],
        contactNumber: [
          { required: true, message: '请输入联系人电话', trigger: 'change' },
        ],
        linkageId: [
          { required: true, message: '请选择所属区域', trigger: 'change' },
        ],
        merchantId: [
          { required: true, message: '请选择所属商户', trigger: 'change' },
        ],
        // storeQuota: [
        //   { required: true, message: '请输入门店总未回额度', trigger: 'change' },
        // ],
        // singleQuota: [
        //   { required: true, message: '请输入单店员总未回额度', trigger: 'change' },
        // ]
      },


      dlgType: 'change',

      // 商户选择
      merchatOptions: [],

      // 三级区域选择
      cityThreeOptions: [],
      loading: false,

      prentIdOptions: [],

      fullscreenLoading: false,
    }
  },
  watch:{},
  computed:{},
  methods:{
    getStoreTemplate(){
      window.open((process.env.NODE_ENV === "development" ? "/api2": "")+`/api/hjx/store/getStoreTemplate`,"_blank")
    },
    deleteStore(id){
      let self = this
        self.$confirm('是否删除').then(() => {
           self.$api.deleteStore({id:id}).then(res=>{
           if(res.code === 200) {
            this.$message({
              message: '删除成功',
              type: 'success'
            });
             this.getStoreList()
          }
      })
      })
   
    },
    // 分页函数
    handleSizeChange(val) {
      this.pageSize = val;
      // 每次调整pagesize后，跳回第一页，保证有数据及请求不会报错
      this.handleCurrentChange(1)
    },

    handleCurrentChange(val) {
      this.currentPage = val

      // 重新请求订单数据
      this.getStoreList()
    }, 

    // 获取门店列表
    getStoreList() {
      let self  = this;
      self.$api.getStoreList({
        page: self.currentPage,
        size: self.pageSize,
        merchantLike: self.storeProgramForm.merchantLike || null,
        storeContactLike: self.storeProgramForm.storeContactLike || null,
        storeLike: self.storeProgramForm.storeLike || null,
        createTimeStart: self.storeProgramForm.createTime instanceof Array && self.storeProgramForm.createTime.length>1 ? self.storeProgramForm.createTime[0] + ' 00:00:00' : null,
        createTimeEnd: self.storeProgramForm.createTime instanceof Array && self.storeProgramForm.createTime.length>1 ? self.storeProgramForm.createTime[1] + ' 23:59:59' : null,
      }).then(res => {
        self.tableData = res.data.records || []
        self.tableTotal = res.data.total
      })
    },

    // 添加门店
    addStore() {
      this.dlgType = 'new'
      this.editStoreOneForm =  {
        id: null,
        code: null,
        storeId: null,
        contactNumber: null,
        contactPerson: null,
        name: null,
        linkageId: null,
        merchantId: null,
        status: 0,
        address: null,
        payQrcode: null,
        storeQuota:null,
        singleQuota:null
      }
      this.$nextTick(()=>{
          this.$refs['editStoreOneForm'].clearValidate()
      })
      this.isDlg = true
    },

    // 修改门店
    editorStore(row) {
      let self = this;
      self.editStoreOneForm =  {
        id: null,
        code: null,
        storeId: null,
        contactNumber: null,
        contactPerson: null,
        name: null,
        linkageId: null,
        merchantId: null,
        status: 0,
        address: null,
        payQrcode: null,
        storeQuota:null,
        singleQuota:null
      },

      self.dlgType = 'change'

      for(let i in self.editStoreOneForm) {
        if(row[i]) self.editStoreOneForm[i] = row[i]
      }
      self.isDlg = true
    },

    // 关闭编辑对话框
    closeEditorStoreDlg() {
      this.isDlg = false
    },

    // 提交编辑（新建或者修改）
    submitEditor() {
      let self = this;
      this.$refs['editStoreOneForm'].validate((valid) => {
        if (valid) {
          let params = {}
          for(let i in self.editStoreOneForm) {
            params[i] = this.editStoreOneForm[i]
          }
          if(self.dlgType === 'change') {
            self.$api.changeStore(params.id, params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '修改成功',
                  type: 'success'
                });
                this.getStoreList()
                this.closeEditorStoreDlg()
              }
            })
          } else {
            self.$api.addStore(params).then(res => {
              if(res.code === 200) {
                this.$message({
                  message: '添加成功',
                  type: 'success'
                });
                this.getStoreList()
                this.closeEditorStoreDlg()
              }
            })
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
     
    },

    // 请求商户列表
    getMerchantList(param) {
      let self = this;
      self.$api.getMerchantList({
        merchantLike: param,
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.merchatOptions = res.data.records
        }
      
      })
    },

    // 请求区域
    getCityThreeList(param) {
      let self = this;
      self.$api.getCityAreaList({
        nameLike: param,
        typeKey: 'area_third',
        page: 1,
        size: 100000,
      }).then(res => {
        if(res.code === 200) {
          self.cityThreeOptions = res.data.records
        }
      
      })
    },

    // 开启门店
    openStore(id) {
      this.$api.openStore(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '开启成功',
            type: 'success'
          });
          this.getStoreList()
        }
      })
    },

    // 关闭门店
    closeStore(id) {
      this.$api.closeStore(id).then(res => {
        if(res.code === 200) {
          this.$message({
            message: '关闭成功',
            type: 'success'
          });
          this.getStoreList()
        }
      })
    },

    // 批量导入
    importStore(file) {
      this.fullscreenLoading = true
      let formData = new FormData()
      formData.append('file', file)
      this.$api.importStore(formData).then(res => {
        this.fullscreenLoading  = false
        if(res.code === 200) {
          this.$message({
            message: '导入成功',
            type: 'success'
          });
          this.getStoreList()
        }
      })
      return false;
    },
      handleSuccess(res, file) {
          console.log(res)
          console.log(file)
      },
      handleBeforeUpload(file) {
          console.log(file);
          let formData = new FormData()
          formData.append("multipartFile", file);
          this.$api.uploadImageFull(formData).then(res => {
              console.log(res);
              this.editStoreOneForm.payQrcode = res.data;
          });
          return false;
      },
      uploadImg() {

      }

  },
  created(){
    
  },
  mounted(){
    let self = this;
    self.getStoreList()
    
    
    self.getMerchantList()
    self.getCityThreeList()

    self.userInfo =JSON.parse(localStorage.getItem('userInfo'))
  }
}
</script>
<style lang="less" scoped>
    .avatar-uploader .el-upload {
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    .avatar-uploader .el-upload:hover {
        border-color: #409EFF;
    }
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
</style>